import { render, staticRenderFns } from "./pos-ticket-actions.vue?vue&type=template&id=3c1e6b0d&scoped=true&"
import script from "./pos-ticket-actions.vue?vue&type=script&lang=ts&"
export * from "./pos-ticket-actions.vue?vue&type=script&lang=ts&"
import style0 from "./pos-ticket-actions.vue?vue&type=style&index=0&id=3c1e6b0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1e6b0d",
  null
  
)

export default component.exports